import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const { FiLayers, FiShield, FiTarget, FiBox, FiCpu, FiInfo, FiBriefcase } = FiIcons;

const Platforms = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen py-16 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-16 border-b border-gray-100 pb-12 text-center md:text-left">
          <h1 className="text-5xl font-black text-brand-dark mb-6 tracking-tighter italic uppercase">
             For Platforms
          </h1>
          <p className="text-brand-orange text-xs font-black uppercase tracking-[0.3em]">
            Enterprise Integration • Framework Licensing
          </p>
        </header>

        <div className="bg-brand-dark rounded-[3rem] p-12 shadow-2xl text-white mb-16">
           <h2 className="text-2xl font-black uppercase tracking-widest mb-6 italic text-brand-orange">Explainable AI Framework</h2>
           <p className="text-gray-300 leading-relaxed font-medium italic text-lg mb-8">
             Vacature.ai is an explainable AI-matching methodology. We provide organizations with a structured analysis framework that integrates into existing workflows to increase the quality and transparency of job matching.
           </p>
           <div className="grid grid-cols-2 gap-4">
              <div className="p-4 bg-white/5 rounded-2xl border border-white/10">
                 <h4 className="text-xs font-black uppercase mb-1 text-white">Semantic Logic</h4>
                 <p className="text-[10px] text-gray-500 italic">Advanced skill gap detection.</p>
              </div>
              <div className="p-4 bg-white/5 rounded-2xl border border-white/10">
                 <h4 className="text-xs font-black uppercase mb-1 text-white">Privacy First</h4>
                 <p className="text-[10px] text-gray-500 italic">No centralized training on data.</p>
              </div>
           </div>
        </div>

        <section className="bg-gray-50 rounded-[2.5rem] p-12 border border-gray-100">
           <h3 className="text-lg font-black text-brand-dark uppercase tracking-widest mb-8 text-center">Implementation Benefits</h3>
           <div className="space-y-6">
              {[
                "Genormaliseerde CV-data extractie",
                "Contextuele vacature analyse",
                "Transparante match-verantwoording",
                "Schaalbare API-integratie"
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-4 p-4 bg-white rounded-2xl shadow-sm border border-gray-100">
                   <div className="w-8 h-8 rounded-full bg-brand-orange/10 text-brand-orange flex items-center justify-center text-xs font-black italic">
                      {i + 1}
                   </div>
                   <p className="text-sm font-bold text-brand-dark italic">{item}</p>
                </div>
              ))}
           </div>
        </section>
      </div>
    </div>
  );
};

export default Platforms;